// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__LeftMenuModel from "./LeftMenuModel.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function LeftMenuMobile(Props) {
  let leftMenuListOpt = Props.leftMenuList;
  const leftMenuList = leftMenuListOpt !== undefined ? leftMenuListOpt : /* [] */ 0;
  const match = React.useState(function () {
    return false;
  });
  const setLeftMenuActive = match[1];
  const leftMenuActive = match[0];
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  let activePage;
  try {
    activePage = Stdlib__List.find((function (item) {
      return Stdlib__List.exists((function (route) {
        return Caml_obj.caml_equal(route, currentRoute);
      }), item.routes);
    }), leftMenuList);
  }
  catch (exn){
    activePage = Buhta_landing__LeftMenuModel.default;
  }
  const position = leftMenuActive ? "fixed" : "static";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: activePage.label,
              className: Cn.fromList({
                hd: "paragraph-large",
                tl: /* [] */ 0
              })
            }),
            JsxRuntime.jsx("img", {
              alt: "dropdown",
              src: StaticAsset.src(leftMenuActive ? "/static/icons/dropdown-up-20.svg" : "/static/icons/dropdown-down-20.svg")
            })
          ],
          className: "flex justify-between",
          onClick: (function (param) {
            Curry._1(setLeftMenuActive, (function (param) {
              return !leftMenuActive;
            }));
          })
        }),
        className: "py-2.5 px-6 sm:px-48"
      }),
      leftMenuActive ? Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, item) {
          const Key = "left_menu_item_" + String(index);
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: Stdlib__List.hd(item.routes),
                className: "py-2.5 flex justify-between",
                onLinkClicked: (function (param) {
                  Curry._1(setLeftMenuActive, (function (param) {
                    return false;
                  }));
                }),
                children: JsxRuntime.jsx("p", {
                  children: item.label,
                  className: Cn.fromList({
                    hd: "paragraph-large",
                    tl: {
                      hd: activePage.label === item.label ? "text-primary" : "text-black-landing",
                      tl: /* [] */ 0
                    }
                  })
                })
              }),
              JsxRuntime.jsx("hr", {
                className: "text-divider"
              })
            ],
            className: "px-6 sm:px-48 first:mt-4"
          }, Key);
        }), leftMenuList)) : null
    ],
    className: "bg-bg " + position + " top-26 bottom-0 w-screen z-10"
  });
}

const make = LeftMenuMobile;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
